const FaqSection = ({ faqs = [] }) => {

  if (!faqs.length) return null;

  return (
    <section className={`faq-section py-5 progress-section`}>
      <div className="container">
        <div className="row mb-4">
          <div className="col-12">
            <h2 className="section-title" data-sal="slide-up" data-sal-duration="300" data-sal-delay="50">
              Frequently asked questions
            </h2>
          </div>
        </div>
        <div className="accordion accordion-flush" id="accordionFlushExample">
          {faqs.map((faq, index) => (
            <div className="accordion-item" key={index} data-sal="slide-up" data-sal-duration="300" data-sal-delay={faq.delay}>
              <h2 className="accordion-header">
                <button className={`accordion-button ${index !== 0 ? "collapsed" : ""}`} type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${index}`} aria-expanded={index === 0} aria-controls={`flush-collapse${index}`}>
                  {faq.question}
                </button>
              </h2>
              <div id={`flush-collapse${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`} data-bs-parent="#accordionFlushExample">
                <div className="accordion-body px-0" dangerouslySetInnerHTML={{
                  __html: faq.answer,
                }}>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
